export default "__VITE_ASSET__DOPaINTM__"